// extracted by mini-css-extract-plugin
export var deleteModal = "_i5-0";